import { HeaderComponent } from './shell/header/header.component';
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { InfoTextFrageDirective } from "@/core/directives/infotext/info-text-frage.directive";
import { InfoTextDirective } from "@/core/directives/infotext/info-text.directive";
import { ContactInformationComponent } from "./components/kontakt/contact-information/contact-information.component";
import { AddressComponent } from "./components/institution/address/address.component";
import { DropDownsModule } from "@progress/kendo-angular-dropdowns";
import { InputsModule } from "@progress/kendo-angular-inputs";
import { DateInputModule, DateInputsModule } from "@progress/kendo-angular-dateinputs";
import { LabelModule } from "@progress/kendo-angular-label";
import { PopupModule } from "@progress/kendo-angular-popup";
import { NavigationItemComponent } from "./components/navigation-item/navigation-item.component";
import { RouterModule } from "@angular/router";
import { ShellComponent } from "./shell/shell/shell.component";
import { FooterComponent } from "./shell/footer/footer.component";
import { AuthenticationShellComponent } from "./shell/authentication-shell/authentication-shell.component";
import { UploadModule, UploadsModule } from "@progress/kendo-angular-upload";
import { HttpClientModule } from "@angular/common/http";
import { DialogModule, DialogService } from "@progress/kendo-angular-dialog";
import { KontaktComponent } from "./components/kontakt/kontakt/kontakt.component";
import { InstitutionComponent } from "./components/institution/institution/institution.component";
import { DocumentViewComponent } from "./components/document/document-view/document-view.component";
import { DocumentViewItemComponent } from "./components/document/document-view-item/document-view-item.component";
import { HerkunftsnachweisDialogComponent } from "./components/document/herkunftsnachweis-dialog/herkunftsnachweis-dialog.component";
import { CKEditorModule } from "@ckeditor/ckeditor5-angular";
import { InfoComponent } from "./components/info/info.component";
import { PreventEmptyFormatterDirective } from "./directives/prevent-empty-formatter";
import { ProzessNavigationComponent } from "./components/prozess-navigation/prozess-navigation.component";
import { FragenProcessStepComponent } from "./features/anfrage/forms/fragen-process-step/fragen-process-step.component";
import { ValidationViewComponent } from "./components/validation-view/validation-view.component";
import { ValidationSummaryComponent } from "./components/validation-summary/validation-summary.component";
import { TooltipsModule } from "@progress/kendo-angular-tooltip";
import { InfotextTooltipComponent } from "./components/infotexttooltip/infotext-tooltip.component";
import { InfoTooltipDirective } from "./directives/infotooltip/info-tooltip.directive";
import { FinanzplanDocumentComponent } from "./components/document/finanzplan-document/finanzplan-document.component";
import { SectionInfoComponent } from "./components/sectioninfo/section-info.component";
import { NgxSpinnerModule } from "ngx-spinner";
import { GridModule } from '@progress/kendo-angular-grid';
import { TranslateModule } from '@ngx-translate/core';
import { FormLayoutComponent } from './components/form-layout/form-layout.component';
import { ChatComponent } from './components/chat/chat.component';
import { ChatModule } from '@progress/kendo-angular-conversational-ui';
import { DocumentSelectionDialogComponent } from './components/document/document-selection-dialog/document-selection-dialog.component';
import { ConfirmationDialogComponent } from './components/dialogs/confirmation-dialog/confirmation-dialog.component';
import { InnerHTMLBypassXSSDirective } from './directives/inner-html-bypass-xss.directive';
import { AnfrageInfoareaComponent } from './features/anfrage/components/anfrage-infoarea/anfrage-infoarea.component';
import { AnfrageInfoComponent } from './features/anfrage/components/anfrage-info/anfrage-info.component';
import { FreigebenDialogComponent } from './components/dialogs/freigeben-dialog/freigeben-dialog.component';
import { ListViewModule } from "@progress/kendo-angular-listview";
import { LayoutModule } from '@progress/kendo-angular-layout';
import { AvatarComponent } from './components/dialogs/freigeben-dialog/avatar/avatar.component';
import { IconsModule } from "@progress/kendo-angular-icons";
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { LiveUsersDialogComponent } from './components/dialogs/live-users-dialog/live-users-dialog.component';
import { CoreCustomElementWrapperModule } from './components/blazor/core-custom-element-wrapper.module';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { TrimRichtextTitleDirective } from './directives/trim-richtext-title.directive';
import { DetailNotificationComponent } from './utils/notifications/detail-notification/detail-notification.component';
import { NotificationModule } from '@progress/kendo-angular-notification';
import { DataprotectionComponent } from './forms/dataprotection-process-step/dataprotection/dataprotection.component';
import { DataprotectionProcessStepComponent } from './forms/dataprotection-process-step/dataprotection-process-step.component';
import { TrimRichtextAriaLabelDirective } from './directives/trim-richtext-aria-label.directive';
import { ExtendedDialogService } from './services/extended-dialog.service';

@NgModule({
    imports: [
        GridModule,
        CommonModule,
        FormsModule,
        DropDownsModule,
        InputsModule,
        ReactiveFormsModule,
        DateInputModule,
        DateInputsModule,
        LabelModule,
        PopupModule,
        RouterModule,
        DialogModule,
        CKEditorModule,
        TooltipsModule,
        TranslateModule,
        ListViewModule,
        ChatModule,
        LayoutModule,
        IconsModule,
        ButtonsModule,
        IndicatorsModule,
        UploadsModule,
        CoreCustomElementWrapperModule
    ],
    declarations: [
        FormLayoutComponent,
        InfoTextDirective,
        InfoTextFrageDirective,
        InnerHTMLBypassXSSDirective,
        TrimRichtextTitleDirective,
        TrimRichtextAriaLabelDirective,
        PreventEmptyFormatterDirective,
        KontaktComponent,
        ContactInformationComponent,
        InstitutionComponent,
        AddressComponent,
        NavigationItemComponent,
        ShellComponent,
        HeaderComponent,
        FooterComponent,
        AuthenticationShellComponent,
        DocumentViewComponent,
        DocumentViewItemComponent,
        HerkunftsnachweisDialogComponent,
        DocumentSelectionDialogComponent,
        InfoComponent,
        ValidationViewComponent,
        ValidationSummaryComponent,
        ProzessNavigationComponent,
        FragenProcessStepComponent,
        InfoTooltipDirective,
        InfotextTooltipComponent,
        FinanzplanDocumentComponent,
        SectionInfoComponent,
        ChatComponent,
        ConfirmationDialogComponent,
        AnfrageInfoareaComponent,
        AnfrageInfoComponent,
        FreigebenDialogComponent,
        AvatarComponent,
        LiveUsersDialogComponent,
        DetailNotificationComponent,
        DataprotectionComponent,
        DataprotectionProcessStepComponent
    ],
    exports: [
        FormLayoutComponent,
        GridModule,
        InfoTextDirective,
        InfoTextFrageDirective,
        InnerHTMLBypassXSSDirective,
        TrimRichtextTitleDirective,
        TrimRichtextAriaLabelDirective,
        PreventEmptyFormatterDirective,
        KontaktComponent,
        ContactInformationComponent,
        InstitutionComponent,
        AddressComponent,
        NavigationItemComponent,
        ShellComponent,
        HeaderComponent,
        FooterComponent,
        AuthenticationShellComponent,
        DocumentViewComponent,
        DocumentViewItemComponent,
        HerkunftsnachweisDialogComponent,
        DocumentSelectionDialogComponent,
        CKEditorModule,
        InfoComponent,
        ValidationViewComponent,
        ValidationSummaryComponent,
        ProzessNavigationComponent,
        FragenProcessStepComponent,
        InfoTooltipDirective,
        InfotextTooltipComponent,
        FinanzplanDocumentComponent,
        SectionInfoComponent,
        NgxSpinnerModule,
        DialogModule,
        PopupModule,
        RouterModule,
        CommonModule,
        FormsModule,
        DropDownsModule,
        InputsModule,
        ReactiveFormsModule,
        DateInputModule,
        DateInputsModule,
        LabelModule,
        UploadModule,
        HttpClientModule,
        ChatComponent,
        ConfirmationDialogComponent,
        AnfrageInfoareaComponent,
        AnfrageInfoComponent,
        CoreCustomElementWrapperModule,
        LiveUsersDialogComponent,
        UploadsModule,
        LayoutModule,
        TranslateModule,
        IndicatorsModule,
        ButtonsModule,
        IconsModule,
        NotificationModule,
        DataprotectionComponent,
        DataprotectionProcessStepComponent
    ],
    providers: [
        { provide: DialogService, useClass: ExtendedDialogService },
    ]
})
export class CoreSharedModule {

}


